import { Button, ButtonGroup, FeedbackMessage } from '@sapphire-react/core';
import { Error } from '@sapphire/icons/react';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useSapphireMedia } from '../hooks';
import { ResultWhiteBox } from '../layout';

type Props = {
  displayButtons?: boolean;
  variant?: 'error' | 'warning' | 'informative';
  submitRef?: RefObject<any>;
};

// To be used in Results section, when calculation request fails (pricing, in our status quo)
export function ErrorMessageWithButtons({
  displayButtons = false,
  variant = 'error',
  submitRef,
}: Props) {
  const { t } = useTranslation('shared');
  const { isExtraSmall, isSmall } = useSapphireMedia();
  const displayButtonsOnLargerScreens =
    displayButtons && !isExtraSmall && !isSmall;

  const handleFormSubmit = () => {
    if (submitRef?.current) {
      submitRef.current();
    }
  };

  return (
    <ResultWhiteBox>
      <FeedbackMessage
        maxWidth={420}
        variant={variant}
        icon={<Error />}
        heading={t('calculationResult.error.heading')}
        body={t('calculationResult.error.description')}
        actions={
          displayButtonsOnLargerScreens && (
            <ButtonGroup
              align={'center'}
              orientation={'horizontal'}
              spacing={'sm'}
            >
              <Button href={'tel:0752-48 45 42'} variant={'secondary'}>
                {t('calculationResult.error.secondaryButton')}
              </Button>
              <Button onPress={handleFormSubmit}>
                {t('calculationResult.error.primaryButton')}
              </Button>
            </ButtonGroup>
          )
        }
      />
    </ResultWhiteBox>
  );
}
